import type { EatalyBreadcrumbItem } from '@/components/eataly-breadcrumbs';
import type { ShopperExperience } from '@/scapi';

/** "Eataly | Milano Smeraldo" → "Milano Smeraldo" */
export function extractLocationLabelAfterPipe(text: string): string {
    const trimmed = text.trim();
    const pipeIndex = trimmed.indexOf('|');
    return pipeIndex >= 0 ? trimmed.slice(pipeIndex + 1).trim() : trimmed;
}

export function buildRestaurantAnalyticsName(restaurantName: string, locationLabel: string): string | undefined {
    const restaurant = restaurantName.trim();
    const location = locationLabel.trim();
    if (!restaurant || !location) {
        return undefined;
    }
    return `${restaurant} | ${location}`;
}

/** Location label from the breadcrumb folder immediately before the current page. */
export function resolveParentLocationLabelFromBreadcrumbs(items: EatalyBreadcrumbItem[]): string | undefined {
    if (items.length < 2) {
        return undefined;
    }

    const label = items[items.length - 2]?.label?.trim();
    return label ? extractLocationLabelAfterPipe(label) : undefined;
}

export function readPageStoreId(page?: ShopperExperience.schemas['Page']): string | null {
    const pageData = page?.data as { storeId?: unknown } | undefined;
    const raw = pageData?.storeId;
    if (typeof raw !== 'string') {
        return null;
    }
    const storeId = raw.trim();
    return storeId || null;
}

/** Editorial / SEO location label from the Page Designer page (e.g. "Milano Smeraldo"). */
export function readPageLocationName(page?: ShopperExperience.schemas['Page']): string | undefined {
    const pageTitle = page?.pageTitle?.trim();
    if (pageTitle) {
        return pageTitle;
    }

    const pageName = page?.name?.trim();
    if (pageName) {
        return pageName;
    }

    return undefined;
}
